import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index'
import {fetchUser} from '@/api/user'

import index from '@/pages/index'
import promotionNews from '@/pages/promotionNews'
import promotionWechat from '@/pages/promotionWechat'
import promotionWechatEffect from '@/pages/promotionWechatEffect'
import promotionWeibo from '@/pages/promotionWeibo'
import promotionLive from '@/pages/promotionLive'
import promotionVideo from '@/pages/promotionVideo'
import promotionInfoFlow from '@/pages/promotionInfoFlow'
import mediaIndex from '@/pages/mediaIndex'
import media from '@/pages/media'
import mediaDetail from '@/pages/mediaDetail'
import cart from '@/pages/cart'
import order from '@/pages/order'
import orderDetail from '@/pages/orderDetail'
import manuscript from '@/pages/manuscript'
// import recharge from '@/pages/recharge'
import rechargeSuccess from '@/pages/recharge-success'
import paySuccess from '@/pages/pay-success'
import me from '@/pages/me'
import profile from '@/pages/profile'
import changePwd from '@/pages/changePwd'
import profileEdit from '@/pages/profileEdit'
import rechargeHistory from '@/pages/rechargeHistory'
import login from '@/pages/login'
import register from '@/pages/register'
import registerProfile from '@/pages/registerProfile'
import forgotPwd from '@/pages/forgotPwd'
import collect from '@/pages/collect'
import solutionFinance from '@/pages/solution/finance'
import solutionApp from '@/pages/solution/appPromotion'
import solutionNewProduct from '@/pages/solution/newProduct'
import solutionGame from '@/pages/solution/game'
import solutionBaby from '@/pages/solution/motherChild'
import solutionBeauty from '@/pages/solution/fashionBeauty'
import solutionFmcg from '@/pages/solution/fmcg'
import solutionTourism from '@/pages/solution/tourism'
import solutionCar from '@/pages/solution/car'
import solutionEcommerce from '@/pages/solution/ecommerce'
import solutionWechatBussiness from '@/pages/solution/microBussiness'
import solutionMiniProgram from '@/pages/solution/smallProgram'
import promotionToutiao from '@/pages/promotionToutiao'
import promotionDouyin from '@/pages/promotionDouyin'
import promotionXhs from '@/pages/promotionXhs'
import agreement from '@/pages/agreement'
import newguest from '@/pages/newguest'
import newguestwx from '@/pages/newguestwx'
import newguestwx2 from '@/pages/newguestwx2'
import newguestxhs1 from '@/pages/newguestxhs1'
import newguestxhs2 from '@/pages/newguestxhs2'
import double12 from '@/pages/double12'
import newguestkol from '@/pages/newguestkol'
import promotionWxzf from '@/pages/promotionWxzf'
import newguestxhs3 from '@/pages/newguestxhs3'
import live from '@/pages/live'
import newmedium from '@/pages/newmedium'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'index',
    component: index,
    meta: {
      noNav: true,
      title: '软盟'
    }
  },
  {
    path: '/promotionNews',
    name: 'promotionNews',
    component: promotionNews,
    meta: {
      noNav: true,
      title: '软文推广'
    }
  },
  {
    path: '/promotionWechat',
    name: 'promotionWechat',
    component: promotionWechat,
    meta: {
      noNav: true,
      title: '微信推广'
    }
  },
  {
    path: '/promotionWechatEffect',
    name: 'promotionWechatEffect',
    component: promotionWechatEffect,
    meta: {
      noNav: true,
      title: '微信推广'
    }
  },
  {
    path: '/promotionWeibo',
    name: 'promotionWeibo',
    component: promotionWeibo,
    meta: {
      noNav: true,
      title: '微博推广'
    }
  },
  {
    path: '/promotionLive',
    name: 'promotionLive',
    component: promotionLive,
    meta: {
      noNav: true,
      title: '网红直播'
    }
  },
  {
    path: '/promotionVideo',
    name: 'promotionVideo',
    component: promotionVideo,
    meta: {
      noNav: true,
      title: '短视频营销'
    }
  },
  {
    path: '/promotionWxzf',
    name: 'promotionWxzf',
    component: promotionWxzf,
    meta: {
      noNav: true,
      title: '公众号引流'
    }
  },
  {
    path: '/promotionInfoFlow',
    name: 'promotionInfoFlow',
    component: promotionInfoFlow,
    meta: {
      noNav: true,
      title: '信息流广告 '
    }
  },
  {
    path: '/mediaIndex',
    name: 'mediaIndex',
    component: mediaIndex,
    meta: {
      noNav: true,
      title: '投广告'
    }
  },
  {
    path: '/media',
    name: 'media',
    component: media,
    meta: {
      title: '媒体'
    }
  },
  {
    path: '/media/detail/:id',
    name: 'mediaDetail',
    component: mediaDetail,
    meta: {
      title: '媒体详情'
    }
  },
  {
    path: '/cart',
    name: 'cart',
    component: cart,
    meta: {
      noNav: true,
      title: '选号车'
    }
  },
  {
    path: '/order',
    name: 'order',
    component: order,
    meta: {
      noNav: true,
      title: '订单'
    }
  },
  {
    path: '/order/detail/:id',
    name: 'orderDetail',
    component: orderDetail,
    meta: {
      title: '订单详情'
    }
  },
  {
    path: '/manuscript',
    name: 'manuscript',
    component: manuscript,
    meta: {
      title: '选择稿件'
    }
  },
  // {
  //   path: '/recharge',
  //   name: 'recharge',
  //   component: recharge,
  //   meta: {
  //     title: '充值'
  //   }
  // },
  {
    path: '/recharge-success',
    name: 'recharge-success',
    component: rechargeSuccess,
    meta: {
      title: '充值成功'
    }
  },
  {
    path: '/pay-success',
    name: 'pay-success',
    component: paySuccess,
    meta: {
      title: '支付成功'
    }
  },
  {
    path: '/me',
    name: 'me',
    component: me,
    meta: {
      noNav: true,
      title: '个人中心'
    }
  },
  {
    path: '/profile',
    name: 'profile',
    component: profile,
    meta: {
      title: '个人资料'
    }
  },
  {
    path: '/profile/edit',
    name: 'profile-edit',
    component: profileEdit,
    meta: {
      title: '个人资料修改'
    }
  },
  {
    path: '/changePwd',
    name: 'changePwd',
    component: changePwd,
    meta: {
      title: '修改密码'
    }
  },
  {
    path: '/recharge/history',
    name: 'rechargeHistory',
    component: rechargeHistory,
    meta: {
      title: '交易流水'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: login,
    meta: {
      title: '登录'
    }
  },
  {
    path: '/register',
    name: 'register',
    component: register,
    meta: {
      title: '注册'
    }
  },
  {
    path: '/register-profile',
    name: 'registerProfile',
    component: registerProfile,
    meta: {
      title: '注册资料填写'
    }
  },
  {
    path: '/forgotPwd',
    name: 'forgotPwd',
    component: forgotPwd,
    meta: {
      title: '忘记密码'
    }
  },
  {
    path: '/collect',
    name: 'collect',
    component: collect,
    meta: {
      title: '我的收藏'
    }
  },
  // 解决方案
  {
    path: '/solution/finance',
    name: 'solutionFinance',
    component: solutionFinance,
    meta: {
      noNav: true,
      title: '金融行业推广解决方案'
    }
  },
  {
    path: '/solution/appPromotion',
    name: 'solutionApp',
    component: solutionApp,
    meta: {
      noNav: true,
      title: 'APP推广解决方案'
    }
  },
  {
    path: '/solution/newProduct',
    name: 'solutionNewProduct',
    component: solutionNewProduct,
    meta: {
      noNav: true,
      title: '新品推广解决方案'
    }
  },
  {
    path: '/solution/game',
    name: 'solutionGame',
    component: solutionGame,
    meta: {
      noNav: true,
      title: '游戏行业解决方案'
    }
  },
  {
    path: '/solution/motherChild',
    name: 'solutionBaby',
    component: solutionBaby,
    meta: {
      noNav: true,
      title: '母婴行业解决方案'
    }
  },
  {
    path: '/solution/fashionBeauty',
    name: 'solutionBeauty',
    component: solutionBeauty,
    meta: {
      noNav: true,
      title: '时尚美容行业解决方案'
    }
  },
  {
    path: '/solution/fmcg',
    name: 'solutionFmcg',
    component: solutionFmcg,
    meta: {
      noNav: true,
      title: '快消行业解决方案'
    }
  },
  {
    path: '/solution/tourism',
    name: 'solutionTourism',
    component: solutionTourism,
    meta: {
      noNav: true,
      title: '旅游行业解决方案'
    }
  },
  {
    path: '/solution/car',
    name: 'solutionCar',
    component: solutionCar,
    meta: {
      noNav: true,
      title: '汽车行业解决方案'
    }
  },
  {
    path: '/solution/ecommerce',
    name: 'solutionEcommerce',
    component: solutionEcommerce,
    meta: {
      noNav: true,
      title: '电商行业解决方案'
    }
  },
  {
    path: '/solution/microBussiness',
    name: 'solutionWechatBussiness',
    component: solutionWechatBussiness,
    meta: {
      noNav: true,
      title: '微商行业解决方案'
    }
  },
  {
    path: '/solution/smallProgram',
    name: 'solutionMiniProgram',
    component: solutionMiniProgram,
    meta: {
      noNav: true,
      title: '微信小程序推广解决方案'
    }
  },
  {
    path: '/promotionToutiao',
    name: 'promotionToutiao',
    component: promotionToutiao,
    meta: {
      noNav: true,
      title: '今日头条'
    }
  },
  {
    path: '/promotionDouyin',
    name: 'promotionDouyin',
    component: promotionDouyin,
    meta: {
      noNav: true,
      title: '抖音推广'
    }
  },
  {
    path: '/promotionXhs',
    name: 'promotionXhs',
    component: promotionXhs,
    meta: {
      noNav: true,
      title: '小红书'
    }
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: agreement,
    meta: {
      noNav: true,
      title: '服务条款'
    }
  },
  {
    path: '/newguest',
    name: 'newguest',
    component: newguest,
    meta: {
      noNav: true,
      title: '新媒体营销,大V推广,大号资源，公众号推广,新媒体推广平台,新媒体营销公司',
      docDesc: '软盟是国内领先的新媒体广告营销平台，签约了100万+优质新媒体大V资源，聚合行业权威意见领袖,明星红人及草根大号,覆盖电商,美妆,母婴,美食旅游等200+行业，帮助广告主实现高效精准快速新媒体广告传播。',
      docKeyword: ' KOL, 大V推广 ,大号资源, 公众号推广,新媒体推广平台,新媒体营销公司'
    }
  },
  {
    path: '/newguestwx',
    name: 'newguestwx',
    component: newguestwx,
    meta: {
      noNav: true,
      title: '微信营销,大V推广,大号资源，公众号推广,新媒体推广平台,新媒体营销公司',
      docDesc: '软盟是国内领先的新媒体广告营销平台，签约了100万+优质新媒体大V资源，聚合行业权威意见领袖,明星红人及草根大号,覆盖电商,美妆,母婴,美食旅游等200+行业，帮助广告主实现高效精准快速新媒体广告传播。',
      docKeyword: ' KOL, 大V推广 ,大号资源, 公众号推广,新媒体推广平台,新媒体营销公司'
    }
  },
  {
    path: '/new_guest_wx2',
    name: 'newguestwx2',
    component: newguestwx2,
    meta: {
      noNav: true,
      title: '微信公众号KOL大号资源平台，电商美妆等全行业精准营销-软盟',
      docDesc: '软盟—覆盖10万+优质微信公众号资源，微信大号资源覆盖电商,美妆,母婴,美食，旅游等200+行业，帮助广告主实现高效精准推广。',
      docKeyword: '微信推广, 微信营销, 社媒营销, 微信大号, 微信KOL'
    }
  },
  {
    path: '/new_guest_xhs1',
    name: 'newguestxhs1',
    component: newguestxhs1,
    meta: {
      noNav: true,
      title: '软盟——小红书推广，专业小红书广告服务商',
      docDesc: '小红书推广,小红书kol,小红书广告,小红书怎么推广,小红书kol报价,小红书kol推广,小红书推广报价,小红书广告投放,小红书达人合作',
      docKeyword: '软盟精准小红书推广平台，整合10万+明星红人、美妆达人等小红书KOL资源，小红书推广专家一对一策划明星推荐、小红书KOL扩散、网红霸屏、红人种草等小红书推广量身定制服务，助力广告主实现小红书推广霸屏营销。'
    }
  },
  {
    path: '/new_guest_xhs2',
    name: 'newguestxhs2',
    component: newguestxhs2,
    meta: {
      noNav: true,
      title: '软盟——小红书推广，专业小红书广告服务商',
      docDesc: '小红书推广,小红书kol,小红书广告,小红书怎么推广,小红书kol报价,小红书kol推广,小红书推广报价,小红书广告投放,小红书达人合作',
      docKeyword: '软盟精准小红书推广平台，整合10万+明星红人、美妆达人等小红书KOL资源，小红书推广专家一对一策划明星推荐、小红书KOL扩散、网红霸屏、红人种草等小红书推广量身定制服务，助力广告主实现小红书推广霸屏营销。'
    }
  },
  {
    path: '/1212',
    name: 'double12',
    component: double12,
    meta: {
      noNav: true,
      title: '软盟双十二 - 新媒体精准营销平台',
      docDesc: '软盟,内容营销,KOL大号,社会化营销,微信营销,自媒体,微博营销,短视频营销,信息流广告',
      docKeyword: '软盟是国内领先的社会化媒体精准营销平台,平台汇聚了超过100万社交新媒体资源,通过整合微信KOL大号、微博大V红人、网红直播,短视频、信息流广告等全网一手优质资源,帮助广告主快速精准匹配到适合渠道资源,致力于为您提供专业的媒体投放解决方案。'
    }
  },
  {
    path: '/new_guest_kol',
    name: 'newguestkol',
    component: newguestkol,
    meta: {
      noNav: true,
      title: '100万+ KOL大号无差价资源平台,电商美妆等全行业精准营销-软盟',
      docDesc: 'KOL资源,KOL平台,KOL大号,微信KOL, KOL推广,小红书KOL,抖音KOL,微博KOL',
      docKeyword: '软盟—覆盖100万+优质KOL资源,KOL大号覆盖电商,美妆,母婴,美食,旅游等200+行业,低成本帮助广告主实现高效精准推广。'
    }
  },
  {
    path: '/new_guest_xhs3',
    name: 'newguestxhs3',
    component: newguestxhs3,
    meta: {
      noNav: true,
      title: '软盟——小红书推广，专业小红书广告服务商',
      docDesc: '小红书推广,小红书kol,小红书广告,小红书怎么推广,小红书kol报价,小红书kol推广,小红书推广报价,小红书广告投放,小红书达人合作',
      docKeyword: '软盟精准小红书推广平台，整合10万+明星红人、美妆达人等小红书KOL资源，小红书推广专家一对一策划明星推荐、小红书KOL扩散、网红霸屏、红人种草等小红书推广量身定制服务，助力广告主实现小红书推广霸屏营销。'
    }
  },
  {
    path: '/live',
    name: 'live',
    component: live,
    meta: {
      noNav: true,
      title: '网红推广_网红直播推广_直播推广_网红营销推广_网红直播营销推广平台',
      docDesc: '网红推广,网红直播推广,网红营销推广,网红直播营销推广,直播营销推广,直播推广,网红营销',
      docKeyword: '软盟是国内领先的网红直播营销推广平台,整合网红推广,网红直播推广,网红营销推广等海量网红直播营销推广资源,覆盖亿万垂直粉丝,迅速引起话题与曝光,低成本高回报,广告效果翻倍。。'
    }
  },
  {
    path: '/newmedium',
    name: 'newmedium',
    component: newmedium,
    meta: {
      noNav: true,
      title: '软盟 - 新媒体精准营销平台',
      docDesc: '软盟,内容营销，KOL大号，社会化营销,微信营销,自媒体,微博营销,短视频营销，信息流广告',
      docKeyword: '软盟是国内领先的社会化媒体精准营销平台，平台汇聚了超过100万社交新媒体资源，通过整合微信KOL大号、微博大V红人、网红直播，短视频、信息流广告等全网一手优质资源，帮助广告主快速精准匹配到适合渠道资源，致力于为您提供专业的媒体投放解决方案'
    }
  },
  {
    path: '/live',
    name: 'live',
    component: live,
    meta: {
      noNav: true,
      title: '软盟——小红书推广，专业小红书广告服务商',
      docDesc: '小红书推广,小红书kol,小红书广告,小红书怎么推广,小红书kol报价,小红书kol推广,小红书推广报价,小红书广告投放,小红书达人合作',
      docKeyword: '软盟精准小红书推广平台，整合10万+明星红人、美妆达人等小红书KOL资源，小红书推广专家一对一策划明星推荐、小红书KOL扩散、网红霸屏、红人种草等小红书推广量身定制服务，助力广告主实现小红书推广霸屏营销。'
    }
  }
]

const router = new Router({
  mode: 'history',
  routes
})

// 判断用户资料是否填写
function isProfileComplete (profile) {
  return !!(profile.attribute.industry &&
    profile.attribute.taxonomies.length !== 0)
}

router.beforeEach((to, from, next) => {
  const profile = store.getters.profile

  // 不需要权限访问的页面列表   todo 以后有复杂的用户身份权限再转入路由配置文件中
  const authPath = [
    'index',
    'login',
    'register',
    'forgotPwd',
    'mediaIndex',
    'media',
    'mediaDetail',
    'promotionNews',
    'promotionWechat',
    'promotionWeibo',
    'promotionLive',
    'promotionVideo',
    'promotionInfoFlow',
    'promotionWechatEffect',
    'promotionXhs',
    'promotionDouyin',
    'promotionToutiao',
    'solutionFinance',
    'solutionApp',
    'solutionNewProduct',
    'solutionGame',
    'solutionBaby',
    'solutionBeauty',
    'solutionFmcg',
    'solutionTourism',
    'solutionCar',
    'solutionEcommerce',
    'solutionWechatBussiness',
    'solutionMiniProgram',
    'agreement',
    'newguest',
    'newguestwx',
    'newguestwx2',
    'newguestxhs1',
    'newguestxhs2',
    'double12',
    'newguestkol',
    'promotionWxzf',
    'newguestxhs3',
    'live',
    'newmedium'

  ]

  // 设置title
  if (to.meta.title) {
    document.title = to.meta.title
    store.commit('SET_TITLE', to.meta.title)
  }
  if (to.meta.docKeyword) {
    document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.docKeyword)
  }
  if (to.meta.docDesc) {
    document.querySelector('meta[name="description"]').setAttribute('content', to.meta.docDesc)
  }

  // 通过router的name判断是否需要权限验证
  if (authPath.indexOf(to.name) !== -1) {
    if (to.name === 'login') {
      console.log('非权限页面跳转登录页拦截', from)
      next()
    } else {
      next()
    }
  } else {
    if (!profile.id) {
      fetchUser().then(res => {
        store.commit('SET_PROFILE', res.data)
        if (to.path !== '/register-profile' && !isProfileComplete(res.data)) {
          next('/register-profile')
        } else {
          next()
        }
      }).catch((e) => {
        next('/login')
        console.log('获取用户信息失败，没有token或token过期', e)
      })
    } else {
      if (to.path !== '/register-profile' && !isProfileComplete(profile)) {
        next('/register-profile')
      } else {
        next()
      }
    }
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js